import { Component } from '@angular/core';
import { ResourceListComponent } from '../../shared/resource-list/resource-list.component';

@Component({
  selector: 'app-recruitment',
  standalone: true,
  imports: [ResourceListComponent],
  template: `<app-resource-list title="Recruitment" apiPath="v1/recruitment" />`
})
export class RecruitmentComponent {}
